module.exports = __webpack_public_path__ + "88edcfeaacaaa1f8bdcd146bf6865067.svg";